<template>
          <b-modal
      id="selectSettings.modal"
      ref="selectSettings.modal"
      v-model="modal"
      centered
      hide-footer
      hide-header
    >
      <template #default="{ hide }">
        <div>
          <div class="card custom-bg border-0">
            <div class="card-header border-0 p-2">
              <div class="w-100 text-center">
                <span class="text-monospace">Pend Application</span>
                <b-icon
                  icon="x-circle"
                  scale="1"
                  variant="danger"
                  @click="hide()"
                  class="card-tools float-right"
                ></b-icon>
              </div>
            </div>
            <div class="card-body">
              <div class="form-group text-center">
                <b class="text-center">{{application.surname}} {{application.firstname}} {{application.lastname}}</b>
                <br/>
                <label>{{application.application_number}}</label>
              </div>
             <div class="form-group">
                <label>Give Reason(s)</label>
              <textarea class="form-control form-control-lg small-font" rows="5" 
                :class="{ 'is-invalid': errors.pend_reason }"
                v-model="pend_reason">
              </textarea>
              <div v-if="errors.pend_reason" class="text-danger">
                    {{ errors.pend_reason }}
              </div>
             </div>
              <div class="d-block m-2">
                <button class="btn btn-sm btn-primary" @click="handlePend">
                  Pend Application
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>

</template>

<script>
export default {
    data() {
        return {
            modal:false,
            pend_reason:"",
            application:"",
            errors: {},
        }
    },
    methods: {
        handlePend(){
        this.errors = {}; // Reset errors
        if (!this.pend_reason) {
          this.errors.pend_reason = "You must provide reason for rejecting this application.";

        }else{
          this.$store.dispatch("spinner/showSpinner"); 
          axios.post('admin/admissionPending' ,{deny_reason:this.pend_reason , applicationId:this.application.id})
          .then((response) => {
            Toast.fire({
              icon:"info",
              title:"Application pended"
            });
            Fire.$emit("acceptAdmission");
            this.modal = false;
            this.$store.dispatch("spinner/hideSpinner"); 
          }).catch((err) => {
            this.$store.dispatch("spinner/hideSpinner"); 
          });

        }}
    },
    created() {
      Fire.$off('PendApplication');
        Fire.$on('PendApplication',(data)=>{
            this.application = data;
            this.modal = true
        })
    },
}
</script>

<style>

</style>